const mkTemplatesOptions = (templates = []) => templates.map((template) => ({
  label: template.title,
  value: `${template.id}`,
}));


export default mkTemplatesOptions;

